<template>
  <div v-if="variant >= 0 && variant <= 2" :class="classes()">
    <Headline size="xs" :staticClass="`${el}__headline`" :noMargin="!$matchMedia.l">
      {{ $t(`taskScheduler.goal.headline${variant === 2 ? '1' : '0'}`) }}
    </Headline>

    <span v-if="$matchMedia.l && variant < 2" :class="`${el}__line`" />

    <div :class="`${el}__nextGoal`">
      <div :class="`${el}__nextGoalIconBackground`">
        <Icon
          :name="variant === 2 ? 'restart-line' : 'flag-line'"
          :class="`${el}__nextGoalIcon`"
          color="primaryBlue"
        />
      </div>
      <div :class="`${el}__nextGoalInner`">
        <Copy v-if="variant !== 2" element="div" color="primaryBlue" bold>
          {{ $t('taskScheduler.goal.nextGoal') }}
        </Copy>
        <Copy element="div" size="l" bold>
          {{ $t(`taskScheduler.goal.nextGoal.subline${variant}`) }}
        </Copy>
      </div>
    </div>

    <template v-if="$matchMedia.l">
      <template v-if="variant === 0">
        <span :class="`${el}__line ${el}__line--dotted`" />

        <div :class="`${el}__last`">
          <div :class="`${el}__lastCircle`" />
          <Copy element="div" color="tertiaryLight">
            {{ $t(`taskScheduler.goal.last`) }}
          </Copy>
        </div>
      </template>

      <ul v-if="variant === 2" :class="`${el}__list`">
        <li
          v-for="(item, index) in $t('taskScheduler.goal.nextGoal.list')"
          :key="`goal-item-${index}`"
        >
          {{ item }}
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import Headline from '@/objects/Headline';
import Copy from '@/objects/Copy';
import Icon from '@/objects/Icon';

export default {
  name: 'TaskGoals',
  components: {
    Headline,
    Copy,
    Icon,
  },
  props: {
    background: {
      type: String,
      default: 'secondaryMintLightest',
      validator: (val) => ['light', 'secondaryMintLightest'].includes(val),
    },
    variant: {
      type: Number,
      default: 0,
      validator: (val) => [0, 1, 2].includes(val),
    },
  },
  data() {
    return {
      el: 'c-taskGoals',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--${this.background}`]: this.background,
          [`${el}__variant--${this.variant}`]: true,
        };
      },
    };
  },
};
</script>
